
import Vue from 'vue';

// Components
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import CharacterCount from '@tiptap/extension-character-count';

export default Vue.extend({
    name: 'RichTextEditor',
    components: {
        EditorContent,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        outline: Boolean,
        placeholder: String,
        maxlength: {
            type: Number,
            default: 1000,
        },
    },
    data() {
        return {
            editor: null as Editor | null,
        };
    },
    mounted() {
        this.editor = new Editor({
            content: this.value,
            extensions: [
                StarterKit,
                CharacterCount.configure({
                    limit: this.maxlength,
                }),
            ],
            onUpdate: () => {
                // HTML
                this.$emit('input', this.editor!!.getHTML());

                // JSON
                // this.$emit('input', this.editor.getJSON())
            },
        });
    },

    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    },

    watch: {
        value(value) {
            if (!this.editor) {
                return;
            }

            // HTML
            const isSame = this.editor.getHTML() === value;

            // JSON
            // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

            if (isSame) {
                return;
            }

            this.editor.commands.setContent(value, false);
        },
    },
});
